export const idx_data_pap_ud = [];

idx_data_pap_ud.push({
  pap_ud: '',
  order_idx: -1,
});

idx_data_pap_ud.push({
  pap_ud: 'Up',
  order_idx: 0,
});

idx_data_pap_ud.push({
  pap_ud: '-',
  order_idx: 1,
});

idx_data_pap_ud.push({
  pap_ud: 'Down',
  order_idx: 2,
});
